var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"camera"},[_c('div',{staticClass:"card-label"},[_c('span',[_vm._v(_vm._s(_vm.data.title))])]),_c('div',{staticClass:"card-image"},[_c('img',{attrs:{"src":require(`../../../../assets/icons/telemetry/camera.png`)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }